import script from "./taskInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./taskInfo.vue?vue&type=script&setup=true&lang=js"

import "./taskInfo.vue?vue&type=style&index=0&id=6f7fd89d&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7fd89d"]])

export default __exports__